/* import __COLOCATED_TEMPLATE__ from './take-first-steps.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type AppService from 'embercom/services/app-service';
import { assetUrl } from '@intercom/pulse/helpers/asset-url';
import type ThemeService from 'embercom/services/theme-service';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    shouldShowPersonalized: boolean;
  };
}

export default class TakeFirstSteps extends Component<Signature> {
  @service declare router: RouterService;
  @service declare appService: AppService;
  @service declare themeService: ThemeService;
  @service declare intercomEventService: $TSFixMe;

  get videoThumbnail1xAssetUrl() {
    if (this.themeService.darkModeEnabled) {
      return assetUrl('/assets/images/automation/fin-readiness/video-dark-mode.svg');
    }
    return assetUrl('/assets/images/automation/fin-readiness/video.svg');
  }

  get wistiaId() {
    return 'rf65anms15';
  }

  navigateToLink = (route: string) => {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'take_first_steps_link',
      place: 'get-started',
      section: 'take_first_steps',
      context: 'automation.get-started.take-first-steps',
      destination: route,
      is_personalized: this.args.shouldShowPersonalized,
    });

    this.router.transitionTo(route);
  };

  handleKeydown = (route: string, event: KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.navigateToLink(route);
    }
  };
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::FinReadiness::TakeFirstSteps': typeof TakeFirstSteps;
    'reporting/automation/ai-insights/fin-readiness/take-first-steps': typeof TakeFirstSteps;
  }
}
